import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'
import { getAlgoliaUserToken, searchInsights } from '@lib/algolia'

import PlaceholderImg from '../../../../site/public/product-img-placeholder.png'
import ProductDiscountMessage from "@components/product/ProductDiscountMessage";

interface props {
  id: string
  name: string
  handle?: string
  description?: string
  price: any
  compareAtPrice: any
  images: {
    url: string
  }[]
  link?: string
  reviews?: string
  stars?: string
  colors?: {
    key: string
    value: string
  }[]
  brand: string
  namedTags: any
}

const ProductCard: FC<props> = ({
  name,
  price,
  compareAtPrice,
  images,
  link = '/',
  colors,
  brand,
  id,
  namedTags
}) => {
  // InsightsSearchViewObjectIDsEvent
  const handleClick = () => {
    const userToken = getAlgoliaUserToken()
    searchInsights('clickedObjectIDs', {
      eventName: 'Clicked product card',
      index: 'shopify_products',
      objectIDs: [id],
      userToken,
    })
  }
  const priceFormatter = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
  })
  const isOnSale = compareAtPrice && compareAtPrice > price;

  return (
    <div className="w-full cursor-pointer relative">
      {isOnSale ? <div className="absolute z-10 text-body3 font-bold text-text-sale bg-brand-polar-white px-2 py-0.5 m-2 rounded-sm">SALE</div> : ''}
      <a href={`/products${link}`} onClick={handleClick}>
        <div className="relative">
          <Image
            src={images?.[0]?.url || '/product-img-placeholder.svg'}
            alt={name}
            width={336}
            height={336}
            layout="responsive"
            placeholder="blur"
            blurDataURL={PlaceholderImg.blurDataURL}
            sizes="(min-width: 1024px) 448px, 768px"
          />
        </div>
      </a>
      <div className="relative flex flex-col">
        <Link href={`/products${link}`} passHref>
          <a>
            <div className="font-normal text-text-subdued uppercase text-body3 mt-3">
              {brand || 'Hoskings Jewellers'}
            </div>
            <p className="font-normal text-text-subdued text-label mt-1">
              {name}
            </p>
            <div className="text-label text-text-subdued font-bold mt-1">
              {compareAtPrice && compareAtPrice > price ? (
                <span>
                  <span className="text-text-sale pr-1">
                    {priceFormatter.format(price)}&nbsp;
                  </span>
                  <span className="line-through text-text-disabled">
                    {priceFormatter.format(compareAtPrice)}
                  </span>
                </span>
              ) : (
                <span>{priceFormatter.format(price)}</span>
              )}
            </div>
            {!isOnSale && <ProductDiscountMessage namedTags={namedTags} />}
          </a>
        </Link>
      </div>
    </div>
  )
}

export default ProductCard
